module.exports = __webpack_public_path__ + "static/media/tiktok.7035e81e.svg";